export default "__VITE_ASSET__DpOaX$sJ__"